// store/supervisorHome/actions/findUserRoles.ts
import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { UserRole } from "../../../@types/userRole";
import axiosInstance from "../../../utils/axiosConfig";

export const findUserRoles = createAsyncThunk(
  "supervisorHome/findUserRoles",
  async (_params, { getState, rejectWithValue }) => {
    const state: any = getState();

    try {
      const user = state?.userAuthentication?.user;
      const locationIds: number[] =
        user?.locations?.map((l: any) => l?.id).filter(Boolean) ?? [];

      const where = {
        location: { in: locationIds },
        enabled: true,
        sourceOrganization: user?.sourceOrganization, // 1 en tu JSON
      };

      const { data } = await axiosInstance.get(`${api.baseURL}userrole`, {
        params: {
          // MUY IMPORTANTE: mandarlo como JSON string para Sails
          where: JSON.stringify(where),
          limit: 1000,
        },

      });

      return data as UserRole[];
    } catch (error: any) {
      console.error("[findUserRoles] error:", error?.response?.data || error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
